<template>
    <div class="tooltips">
        <button class="helpButton"
            @click="openHelp(helpbookmark), $tera.project.TrialWizard.helpToggle = !$tera.project.TrialWizard.helpToggle">?</button>
        <span class="tooltiptext">Help</span>
    </div>

</template>

<script>
import HelpMixin from "../mixins/HelpMixin";

export default {
    name: "HelpTooltip",
    props: {
        helpbookmark: String
    },
    mixins: [HelpMixin],
    methods: {

    }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
/* Custom Help */
.helpButton {
    border-radius: 10px;
    background-color: #4f6597;
    color: white;
    border-color: white;
    font-size: 10px;
    /* position: absolute; */
}

/* Tooltip container */
.tooltips {
    position: relative;
    display: inline-block;
    /* border-bottom: 1px dotted black; */
}

/* Tooltip text */
.tooltips .tooltiptext {
    visibility: hidden;
    width: 55px;
    background-color: #475c8d;
    color: #fff;
    text-align: center;
    padding: 6px;
    border-radius: 6px;
    font-size: 12px;
    margin-left: 5px;

    /* Position the tooltip text - see examples below! */
    position: absolute;
    z-index: 1;
    /* transition */
    opacity: 0;
    transition: opacity 1s;
}

.tooltips .tooltiptext::after {
    content: "";
    position: absolute;
    top: 50%;
    right: 100%;
    margin-top: -5px;
    border-width: 5px;
    border-style: solid;
    border-color: transparent #475c8d transparent transparent;
}

/* Show the tooltip text when you mouse over the tooltip container */
.tooltips:hover .tooltiptext {
    visibility: visible;
    /* transition */
    opacity: 1;
}
</style>
